const localization: any = {
  en: {
    'cip-title-header': 'Employee Search',
    'Employee Info': 'Employee Info',
    'Full Name': 'Full Name',
    'Emp Status': 'Emp Status',
    'Emp Type': 'Emp Type',
    'Country': 'Country',
    'City': 'City',
    'Email': 'Email',
    'Mgr Email': 'Mgr Email',
    'Office': 'Office',
    'Contact': 'Contact',
    'loader-fetching-customer-profile': 'Fetching Employee info...',
    'typing-indicator': 'Start typing to search employees...'
  }
};

export default localization; 